// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"33838b0b","239":"ef842590","342":"827f8c5f","382":"9e0f09de","453":"8a24bcf0","455":"b48b22f6","568":"3cc3301e"}[chunkId] + ".chunk.js";
};